import * as React from "react";

export const Fragment: React.SFC<any> = (props) => props.children;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/components/Fragment.tsx